import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '../forms/forms.module';
import { IconButtonModule } from '../icon-buttons/icon-button.module';
import { FilterGroupComponent } from './filter-group.component';
import { FilterItemComponent } from './filter-item.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IconButtonModule,
    ],
    exports: [
        FilterGroupComponent,
        FilterItemComponent
    ],
    declarations: [
        FilterGroupComponent,
        FilterItemComponent
    ]
})
export class FilterGroupModule {
}
